/**
 * converts our stats state object to a shape required by the chart lib
 * @returns chartsData, feeded to the collapsiblechart component
 * shape {xAxis, series}
 */
export const getChartData = (dataKey, loggedInUser, areas) => {
  if (areas.length === 0) return {};
  if (!(areas[0]?.data?.timestamps || areas[1]?.data?.timestamps)) return {};
  return {
    xAxis: {
      categories: areas[0]?.data?.timestamps || areas[1]?.data?.timestamps,
      visible: false,
    },
    series: areas.reduce((filtered, area, idx) => {
      if (idx > 1) return filtered;
      if (!area.data?.stats) return filtered;

      filtered.push({
        name: dataKey,
        data: area.data.stats,
      });
      return filtered;
    }, []),
    exporting: {
      menuItemDefinitions: {
        // Custom definition
        label: {
          onclick: function () {
            this.renderer
              .label("You just clicked a custom menu item", 100, 100)
              .attr({
                fill: "#a4edba",
                r: 5,
                padding: 10,
                zIndex: 10,
              })
              .css({
                fontSize: "1.5em",
              })
              .add();
          },
          text: "Show label",
        },
      },
      buttons: {
        contextButton: {
          // ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "viewData"]
          menuItems: loggedInUser // hide download button if user not signed in
            ? [
                "viewFullscreen",
                "downloadPNG",
                "downloadCSV",
                "downloadXLS",
                "separator",
              ]
            : ["viewFullscreen"],
        },
      },
    },
    unit: areas[0]?.data?.unit || areas[1]?.data?.unit,
  };
};

/**
 * converts our stats state object to a shape required by the chart lib
 * @returns chartsData, feeded to the collapsiblechart component
 * shape {xAxis, series}
 */
export const getWeatherChartdata = (weatherStats, loggedInUser,t) => {
  if (JSON.stringify(weatherStats) === "{}") return {};

  return {
    xAxis: {
      categories: weatherStats.time,
      visible: false,
    },
    series: Object.keys(weatherStats).reduce((filtered, k, idx) => {
      if (k === "time") return filtered;
      filtered.push({
        name: t(WEATHER_KEYS_NAMES[k]),
        data: weatherStats[k],
      });
      return filtered;
    }, []),
    exporting: {
      buttons: {
        contextButton: {
          // ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS", "viewData"]
          menuItems: loggedInUser // hide download button if user not signed in
            ? [
                "viewFullscreen",
                "downloadPNG",
                "downloadCSV",
                "downloadXLS",
                "separator",
              ]
            : ["viewFullscreen"],
        },
      },
    },
  };
};

const WEATHER_KEYS_NAMES = {
  time: 'Map.time',
  temperature_2m_max: 'Map.temp_max',
  temperature_2m_min: 'Map.temp_min',
  precipitation_sum: 'Map.percp_sum',
  snowfall_sum: 'Map.snow_sum',
  windspeed_10m_max: 'Map.wind_speed_max',
};
